/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {UserDetailsModel} from "../../models/user-details-model";
import {UserCreateModel} from "../../models/user-create-model";


export interface AccountUsersPostParams {
    body?: UserCreateModel,
    accountGuid: string;
}

export function accountUsersPost(http: HttpClient, rootUrl: string, params: AccountUsersPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<UserDetailsModel>> {
    const rb = new RequestBuilder(rootUrl, accountUsersPost.PATH, 'post');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.body(params.body, 'application/json');

    if (params.accountGuid) {
        rb.path('accountGuid', params.accountGuid, { 'style': 'simple' });
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<UserDetailsModel>;
        })
    );
}

accountUsersPost.PATH = '/api/v1/accounts/{accountGuid}/users'
